export const conteudos = {
  hero: {
    label: 'Content',
    title: 'Technical and Structural Analysis',
    subtitle: 'Articles on wealth engineering, governance, and disciplined execution. No promises. With method.',
  },
  articles: [
    {
      category: 'Wealth Engineering',
      title: 'Credit Structuring via Consortium: Variables and Restrictions',
      excerpt: 'Technical analysis of variables impacting credit structuring through regulated consortiums.',
      date: 'Jan 15, 2024',
      readTime: '8 min',
    },
    {
      category: 'Governance',
      title: 'Scenario Modeling: Base and Stress Testing',
      excerpt: 'How to build realistic scenarios and stress tests for structured wealth decisions.',
      date: 'Jan 10, 2024',
      readTime: '12 min',
    },
    {
      category: 'Method',
      title: 'Wealth Diagnosis: Beyond Risk Profile',
      excerpt: 'Methodology for structural analysis that goes beyond conventional profile questionnaires.',
      date: 'Jan 05, 2024',
      readTime: '10 min',
    },
    {
      category: 'Execution',
      title: 'Contemplated Letters: Curation and Document Validation',
      excerpt: 'Technical process of validation, operational risk analysis, and transfer monitoring.',
      date: 'Dec 28, 2023',
      readTime: '9 min',
    },
    {
      category: 'Corporate Structuring',
      title: 'Corporate Asset Acquisition: Governance and Clarity',
      excerpt: 'How to structure headquarters and operational asset acquisitions with method and transparency.',
      date: 'Dec 20, 2023',
      readTime: '11 min',
    },
    {
      category: 'Analysis',
      title: 'Consortium Regulations: Critical Reading and Key Variables',
      excerpt: 'Technical guide for regulation analysis, restriction identification, and operational variables.',
      date: 'Dec 15, 2023',
      readTime: '14 min',
    },
  ],
  cta: {
    title: 'Structure Your Wealth with Method',
    subtitle: 'Schedule a strategic assessment and receive personalized technical analysis.',
    primary: 'Schedule Strategic Assessment',
    secondary: 'Talk to Specialist',
  },
};